import { Box } from '@mui/material';
import AMSatelliteReportDetailedPage from './AMSatelliteReportDetailedPage';
import AmSatelliteReportSummaryPage from './AmSatelliteReportSummaryPage';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../../css/print.css'; // Importing print styles

const AmSatelliteReport = () => {
  const { farmId, language, accessKey } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  if (!farmId || !accessKey) return null;

  return (
    <Box
      className="satellite-report-container pdf-no-break"
      sx={{
        width: '210mm', // A4 width
        minHeight: '297mm', // A4 height
        margin: '0 auto',
        backgroundColor: '#ffffff',
        boxSizing: 'border-box',
        padding: '5mm', // A4 margin
        '@media print': {
          width: '210mm',
          minHeight: '297mm',
          padding: '0',
          margin: '0',
          boxShadow: 'none',
          backgroundColor: 'white !important',
        },
      }}
    >
      <Box
        className="pdf-section"
        sx={{
          pageBreakAfter: 'auto',
          marginBottom: '2mm',
          '@media print': {
            pageBreakAfter: 'avoid',
          },
        }}
      >
        <AmSatelliteReportSummaryPage
          farmId={farmId}
          language={language}
          accessKey={accessKey}
        />
      </Box>
      <Box
        className="pdf-section"
        sx={{
          marginTop: '3mm',
          '@media print': {
            pageBreakBefore: 'auto',
          },
        }}
      >
        <AMSatelliteReportDetailedPage farmId={farmId} accessKey={accessKey} />
      </Box>
    </Box>
  );
};

export default AmSatelliteReport;
